import type { EmbarcacaoBaseTecnicaField } from "@/modules/embarcacoes";
import { formatCnpj } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const BASE_TECNICA_ID = "base-tecnica";
export const BASE_TECNICA_TITLE = "Base Técnica";
export const BASE_TECNICA_TEST_ID = "embarcacao-base-tecnica";
export const BASE_TECNICA_LOADING_MESSAGE = "Carregando a Base Técnica da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const BASE_TECNICA_EMPTY_STATE = {
  title: "Nenhuma informação de Base Técnica disponível",
  description: "Assim que houver dados técnicos para esta embarcação, eles aparecerão nesta seção.",
};

/**
 * Os 27 campos da seção, na ordem e nas colunas do protótipo (AC3). O grid os
 * distribui em duas colunas, preenchendo a linha da esquerda para a direita.
 *
 * O protótipo mantém Grupo e CNPJ para Faturamento no mesmo par, o que deixa
 * IMO sozinho na coluna da esquerda: por isso Grupo abre linha. Daí em diante o
 * preenchimento corrido já reproduz as colunas desenhadas, par a par.
 */
export const BASE_TECNICA_FIELDS: readonly DetailFieldDefinition<EmbarcacaoBaseTecnicaField>[] = [
  { key: "nome", label: "Embarcação" },
  { key: "nomeAntigo", label: "Nome antigo" },
  { key: "nomeAbreviado", label: "Nome Abreviado" },
  { key: "acronimo", label: "Acrônimo" },
  { key: "tipo", label: "Tipo" },
  { key: "empresaOrigem", label: "Empresa Origem (Ocean/CBO)" },
  { key: "mmsi", label: "MMSI" },
  { key: "vesselSignalLetters", label: "Vessel Signal Letters" },
  { key: "imo", label: "IMO" },
  { key: "grupo", label: "Grupo", startsRow: true },
  { key: "cnpjFaturamento", label: "CNPJ para Faturamento", format: formatCnpj },
  // O protótipo qualifica os dois campos do armador; o AC3 os cita abreviados.
  { key: "armador", label: "Nome do Armador" },
  { key: "cnpj", label: "CNPJ do Armador", format: formatCnpj },
  { key: "centroCusto", label: "Centro de Custo" },
  { key: "sisterVessels", label: "Sister Vessels" },
  { key: "possuiReb", label: "Possui REB?" },
  { key: "bandeiraSuspensa", label: "Bandeira Suspensa" },
  { key: "bandeira", label: "Bandeira" },
  { key: "paisConstrucao", label: "País de Construção" },
  { key: "estaleiroConstrucao", label: "Estaleiro de Construção" },
  { key: "anoBatimentoQuilha", label: "Ano do Batimento de Quilha" },
  { key: "anoFinalConstrucao", label: "Ano Final da Construção" },
  { key: "idade", label: "Idade" },
  { key: "anoModernizacao", label: "Ano Modernização" },
  { key: "sistemaGerencial", label: "Sistema Gerencial" },
  { key: "totalPessoas", label: "Quantidade total de Pessoas (POB)" },
  { key: "situacaoEmbarcacao", label: "Situação da Embarcação (Ativo/Inativo)" },
];
